<template>
    <section class="border rounded p-3 my-3">
        <h6>Аннулирование отчётов</h6>
        <b-alert v-if="error" show variant="danger">{{ error }}</b-alert>
        <template v-if="details">
            <p v-if="details.legacy_request_id" class="small text-muted">Прежний номер аннулирования: №{{ details.legacy_request_id }}</p>
            <div v-for="row in details.reports" :key="row.shift_id" class="mb-2">
                <span v-if="row.missing">Отчёт №{{ row.shift_id }} — отсутствует в архиве</span>
                <router-link v-else :to="{name: 'report-card', params: {id: row.shift_id}}">Отчёт №{{ row.shift_id }}</router-link>
                <span class="ml-2">{{ row.reason || 'Причина не сохранилась' }}</span>
            </div>
            <b-alert v-if="request.status === 'completed' && (details.telegram_status !== 'completed' || details.reconciliation_pending)" show variant="warning">
                Отчёты аннулированы. {{ details.telegram_error || 'Обновление отчётов и отправка уведомления в Telegram ещё не завершены.' }}
                <b-button v-if="canRetry" size="sm" variant="outline-warning" :disabled="busy" @click="retry">Повторить обработку</b-button>
            </b-alert>
            <b-button v-if="canEdit" size="sm" variant="outline-secondary" @click="editing = !editing">{{ editing ? 'Закрыть' : 'Изменить отчёты и причины' }}</b-button>
            <template v-if="editing">
                <ReportAnnulmentEditor v-model="reports" :type-id="request.request_type_id" :process-id="request.building_process_id" :request-id="request.id" />
                <b-button size="sm" variant="primary" :disabled="busy" @click="save">Сохранить состав</b-button>
            </template>
        </template>
    </section>
</template>
<script>
import api from '@/utils/api';
import ReportAnnulmentEditor from './ReportAnnulmentEditor.vue';
export default {
    components: {ReportAnnulmentEditor}, props: {request: Object, canEdit: Boolean},
    data: () => ({details: null, reports: [], error: '', editing: false, busy: false, refreshTimer: null, refreshAttempts: 0, revision: 0}),
    computed: {
        userId() { const user = this.$store.state.user || this.$store.getters.currentUser || {}; return Number(user.userId || user.user_id); },
        canRetry() { return this.$store.getters.isAdmin || (this.request.participants || this.request.Participants || []).some(p => Number(p.user_id) === this.userId && p.role === 'approver'); }
    },
    watch: {request: {immediate: true, handler() { this.load(); }}},
    beforeDestroy() { ++this.revision; clearTimeout(this.refreshTimer); },
    methods: {
        async load() {
            const revision = ++this.revision;
            clearTimeout(this.refreshTimer);
            try {
                const {data} = await api.get(`/api/requests/items/${this.request.id}/report-annulment`);
                if (revision !== this.revision) return;
                this.details = data;
                if (!this.editing) this.reports = data.reports.map(row => ({shift_id: row.shift_id, reason: row.reason}));
                if (this.request.status === 'completed' && data.telegram_status === 'pending' && this.refreshAttempts++ < 5) this.refreshTimer = setTimeout(() => this.load(), 2000);
            } catch (e) { if (revision === this.revision) this.error = e.response && e.response.data.message || 'Не удалось загрузить состав.'; }
        },
        async save() { await this.write('put', '', {reports: this.reports}); },
        async retry() { await this.write('post', '/retry', {}); },
        async write(method, suffix, body) { this.busy = true; this.error = ''; try { await api[method](`/api/requests/items/${this.request.id}/report-annulment${suffix}`, body); this.editing = false; await this.load(); this.$emit('saved'); } catch (e) { this.error = e.response && e.response.data.message || 'Не удалось выполнить действие.'; } finally { this.busy = false; } }
    }
};
</script>
